<ng-container *ngIf="word">
  <div *ngIf="btnClose"
       class="tooltip-head-box">

    <div class="tooltip-word-list">
      <!-- div class="tooltip-word-box"
           *ngFor="let poomsa of word?.partOfSpeech">{{ GetPoomsaTxt(poomsa) }}</div -->
    </div>

    <!-- div class="derivative"
         *ngIf="getDerivative(word)">→{{ getDerivative(word) }}</div -->

    <a class="tooltip-close-btn"
       (click)="onClose($event)"></a>

  </div>

  <div class="tooltip-body-box">

    <app-word-play-btn class="tooltip-option-box"
                       [word]="word"></app-word-play-btn>
    <app-word-disp [word]="word"
                   [wrapHanja]="true"
                   class="small"></app-word-disp>
  </div>

  <div class="tooltip-foot-box">
    <!-- 기본 뜻이 있는 경우 -->
    <div class="meaning-box"
         *ngIf="getDefaultMeaning(word)">
      <div class="mean-txt"
           [innerHTML]="getDefaultMeaning(word) | resize | keepHtml"></div>
    </div>

    <!-- 뜻이 여러개인 경우 -->
    <div class="meaning-box"
         *ngFor="let meaning of getNumberedMeanings(word); let idx = index">
      <div class="mean-txt flex">
        <div class="txt-box-num">{{ (idx + 1).toString() + '.' }}</div>
        <div class="txt-box-meaning"
             [innerHTML]="meaning | resize | keepHtml"></div>
      </div>
    </div>
    <!-- div class="meaning-box"
         *ngIf="getMoreMeanings(word) > 0">
      <div class="mean-txt more"><{{ getMoreMeanings(word) }}개의 뜻이 더 있습니다.></div>
    </div -->
  </div>

  <div class="tooltip-link-box">
    <a class="tooltip-link-btn"
       (click)="onGotoDetail($event)">

      <!-- span class="txt more">{{ getMoreMeanings(word) > 0 ? getMoreMeanings(word) + "개의 뜻이 더 있습니다." : "" }}</span -->
      <span *ngIf="getMoreMeanings(word) > 0"
            class="txt more">{{ getMoreMeanings(word) }}개의 뜻이 더 있습니다.</span>
      <span class="txt">자세히 보기</span>
      <i class="ic ic-link"></i>
    </a>
  </div>
</ng-container>
